import React from 'react'
import QRCard from './QRCard'
import './QRCard.scss'

const QRList = ({ items }) => {
  // Safety check: ensure items is always an array
  const safeItems = items || []

  return (
    <div className='qr-grid-container'>
      {safeItems.map((item, index) => (
        <div key={item.id || item.code || `qr-${index}`} className="qr-grid-item">
          <QRCard item={item} />
        </div>
      ))}
    </div>
  )
}

export default QRList
